import React from 'react';
import ModulesView from './ModulesView';

const ModulesContainer = (props) => {
  return <ModulesView {...props} />;
};

export default ModulesContainer;
